import { Box, Paper } from "@mui/material";
import { PropsWithChildren, ReactNode } from "react";
import Skeleton from "react-loading-skeleton";
import { DefaultPageHeader, DefaultPageHeaderProps } from "./default-page-header";

type DefaultPageProps = {
  narrow?: boolean;
  otherComponet?: ReactNode;
  loading?: boolean;
  pagination?: JSX.Element; // Add pagination prop
} & DefaultPageHeaderProps;

export const DefaultPage = (
  props: PropsWithChildren<DefaultPageProps>
): JSX.Element => {
  return (
    <Box
      width="100%" // ✅ Force full width for parent container
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
      }}
    >
      <DefaultPageHeader {...props} />

      {props.pagination && (
        <Box display="flex" justifyContent="start" mt={2}>
          {props.pagination}
        </Box>
      )}

      <Paper
        component="div"
        sx={{
          width: "100%", // ✅ Force full width for Paper
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexGrow: 1,
          minHeight: 200,
          padding: props.narrow ? "15px" : "8px",
          overflow: "hidden", // ✅ Prevent table from overflowing out of Paper
        }}
        {...(props.narrow && {
          style: { padding: 25 },
        })}
      >
        {props?.loading ? (
          <Box width="100%">
            {/* Shimmering Table Skeleton */}
            {Array.from({ length: 10 }).map((_, index) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                paddingY={1}
                paddingX={2}
                borderBottom="1px solid #e0e0e0"
              >
                <Skeleton circle width={40} height={40} />
                <Box flex={1} marginLeft={2}>
                  <Skeleton width="30%" height={20} style={{ marginBottom: 6 }} />
                  <Skeleton width="40%" height={16} style={{ marginBottom: 6 }} />
                  <Skeleton width="20%" height={16} />
                </Box>
                <Box width={100} marginRight={2}>
                  <Skeleton width="80%" height={20} />
                </Box>
                <Box display="flex" gap={1}>
                  <Skeleton circle width={30} height={30} />
                  <Skeleton circle width={30} height={30} />
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <Box width="100%"> {/* ✅ Force content (table) to take full width */}
            {props.children}
          </Box>
        )}
      </Paper>
    </Box>
  );
};

